import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
// import { UserFullNameByIdPipe } from "./user-full-name-by-id.pipe";
import {DateAddDaysPipe} from "./date-add-days.pipe";
import {S3LinkPipe} from "./s3-link.pipe";
import {InteresseMaturatePipe} from './interesse-maturate.pipe';
import {HighlightPipe} from './highlight.pipe';
import {ContractAmountSumPipe} from "./contract-amount-sum.pipe";
import {GetMonthOfawsDatePipe} from "./get-month-ofaws-date.pipe";

@NgModule({
    declarations: [DateAddDaysPipe, S3LinkPipe, GetMonthOfawsDatePipe,
        InteresseMaturatePipe, HighlightPipe, ContractAmountSumPipe],
    imports: [IonicModule],
    exports: [DateAddDaysPipe, S3LinkPipe, GetMonthOfawsDatePipe,
        InteresseMaturatePipe, HighlightPipe, ContractAmountSumPipe]
})
export class PipesModule {
    static forRoot() {
        return {

            ngModule: PipesModule,
            providers: [S3LinkPipe, GetMonthOfawsDatePipe,
                InteresseMaturatePipe, HighlightPipe, ContractAmountSumPipe],
        };
    }
}
